<button mat-button (click)="back()">
  <mat-icon>arrow_back</mat-icon>
  {{'navigation.back' | transloco}}
</button>
